import { BuregerIcon } from "components/ui/icons/quotations/BurgerIcon"

type Props = { onClick?: () => void; className?: string; style?: React.CSSProperties }

export const ButtonBurger = ({ onClick, className, style }: Props) => {
	return (
		<button onClick={onClick} className={className} style={style}>
			<BuregerIcon />
		</button>
	)
}
